import { render, staticRenderFns } from "./EvaluationScore.vue?vue&type=template&id=51b220a6&scoped=true"
import script from "./EvaluationScore.vue?vue&type=script&setup=true&lang=js"
export * from "./EvaluationScore.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EvaluationScore.vue?vue&type=style&index=0&id=51b220a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b220a6",
  null
  
)

export default component.exports